<form class="form-group" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="close-container">
    <mat-icon class="close-icon" (click)="closeDialog()"></mat-icon>
  </div>
  <div class="title title--md dialog" mat-dialog-title>Faculty Member Search</div>
  <mat-dialog-content>
    <div class="smallerText">Let's check to see if the faculty member is already in our records.
      Please fill in the following information and click search to look them up.</div>
      <div class="smallerText text-info">* = Required Field</div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">First Name</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{firstNameControl}}" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">Last Name*</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{lastNameControl}}" required type="text" />
        <div class="required-text" *ngIf="invalidRequiredField(lastNameControl)">
          Last Name is required
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="title title--xs">Email</div>
        <input class="form-control-sm w-100" [disabled]="!editPrivileges" formControlName="{{primaryEmailControl}}" type="text" />
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="dialog-btn-container">
      <button (click)="closeDialog()" class="btn btn--outline" type="button">Cancel</button>
      <button class=" btn btn--solid btn--red" type="submit" [disabled]="canAddFaculty()">Search</button>
    </div>
  </mat-dialog-actions>

</form>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
